import { variant } from './types';

/** Estados de Order que tienen variante propia en `SpecialTag`. */
const ORDER_STATE_VARIANTS: Readonly<Record<string, variant>> = {
  open: variant.Open,
  managed: variant.Managed,
  'pending-work': variant.PendingWork,
  'work-in-progress': variant.WorkInProgress,
  'in-progress': variant.InProgress,
  paused: variant.Paused,
  'pending-validation': variant.PendingValidation,
  'pending-at-validation': variant.PendingATValidation,
  validated: variant.Validated,
  'pending-certification': variant.PendingCertification,
  partial: variant.Partial,
  end: variant.End,
  annulled: variant.Annulled,
};

/**
 * Estado de una Order → variante de `SpecialTag` que lo pinta. `null` si el
 * estado no es uno conocido (no se inventa una etiqueta).
 */
export function orderStateVariant(
  state: string | null | undefined
): variant | null {
  if (!state) return null;
  return Object.prototype.hasOwnProperty.call(ORDER_STATE_VARIANTS, state)
    ? ORDER_STATE_VARIANTS[state]
    : null;
}
